module.exports = __webpack_public_path__ + "img/apple-touch-icon-144x144.e86f1e4f.png";